<div class="modal d-block position-relative">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <app-privacy-policy [noClose]="true"></app-privacy-policy>
    </div>
  </div>
</div>